import React, { useState } from "react"; 
import "./css/Sidebar.css";
import { FaUserDoctor } from "react-icons/fa6";
import { MdHome } from "react-icons/md";
import { FaClock } from "react-icons/fa";
import { IoIosNotifications } from "react-icons/io";
import { GoCreditCard } from "react-icons/go";
import { IoMdSettings } from "react-icons/io";
import { FaCircleExclamation } from "react-icons/fa6";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux"; 
import { logOutSuccess } from '../store/auth/action';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; 
import {
  FaUserTie,
  FaUser,
  FaUsers,
  FaStore,
  FaChartLine,
  FaBoxes,
  FaReceipt
} from "react-icons/fa";
import { MdShoppingBag } from "react-icons/md";
import { FaUserGroup } from "react-icons/fa6";
import { FiBox, FiShoppingCart, FiEdit, FiHeart } from "react-icons/fi";
import { FaShoppingCart, FaNewspaper, FaHeart } from "react-icons/fa";
import { FaQuestionCircle, FaEnvelopeOpenText } from "react-icons/fa"; 
import { FaLeaf, FaFlask, FaPlane, FaShippingFast  } from "react-icons/fa"; 
import { Modal, Button } from 'react-bootstrap';
import PermContactCalendarIcon from '@mui/icons-material/PermContactCalendar';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import CategoryIcon from '@mui/icons-material/Category';
import SellerManagement from "./sellermanagement/SellerManagement";

export default function Sidebar({ isCollapsed }) {

  const permissions = JSON.stringify(localStorage.getItem("permissions"))
  const location = useLocation();
  const pathParts = location.pathname.split('/');
  const id = pathParts[2];
  

  const navigate = useNavigate(); 
  const dispatch = useDispatch(); 


  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);

  const handleLogoutClick = (e) => {
    e.preventDefault();
    setShowLogoutConfirm(true);
  };

  // Function to close the logout confirmation modal
  const handleCloseLogoutConfirm = () => {
    setShowLogoutConfirm(false);
  };

  const handleConfirmLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("adminInfo");
    localStorage.removeItem("permissions")
    dispatch(logOutSuccess());

    toast.success('Admin logged out successfully!', {
      position: "top-right", // You can customize this
      autoClose: 7000, // Toast disappears after 3 seconds
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
    setShowLogoutConfirm(false);
    setTimeout(() => {
      navigate("/backoffice/login");
    }, 700);
  };



  return (
    <div className={`DASH ${isCollapsed ? 'collapsed' : ''}`}>
      <nav className="Dashboard01 ">
        <div className="last">
          <Link
            to="/backoffice/"
            className={`CommonName ${location.pathname === "/backoffice/" ? "active" : ""
              }`}
          >
            <div className="top01">
              <span className="icon01">
                <MdHome className="Home01" />
              </span>
              <div className="name01">
                <h1 className="text01">Dashboard</h1>
              </div>
            </div>
          </Link>
        </div>
        {
          permissions.includes("view_seller") && (
            <div className="last">
              <Link
                to="/backoffice/sellermanagement"
                className={`CommonName ${location.pathname === "/backoffice/sellermanagement" ? "active"
                  : location.pathname === `/seller-details/${id}` ? "active" : ""
                  }`}
              >
                <div className="top01">
                  <div className="icon01">
                    <FaUser className="Home02" />
                  </div>
                  <div className="name01">
                    <h1 className="text01">Seller Management</h1>
                  </div>
                </div>
              </Link>
            </div>
          )
        }

        {
          permissions.includes("view_user") && (
            <div className="last">
              <Link
                to="/backoffice/Usermanagement"
                className=
                {`CommonName ${location.pathname === "/backoffice/Usermanagement" ? "active"
                  : location.pathname === `/reviewuser/${id}` ? "active" : ""
                  }`}
              >
                <div className="top01">
                  <div className="icon01">
                    <FaUserGroup className="Home02" />
                  </div>
                  <div className="name01">
                    <h1 className="text01">User Management</h1>
                  </div>
                </div>
              </Link>
            </div>
          )
        }
        {
          permissions.includes("view_role") && (
            <div className="last">
              <Link
                to="/backoffice/rolemanagement"
                className=
                {`CommonName ${location.pathname === "/backoffice/rolemanagement" ? "active"
                  : location.pathname === `/rolecreate` ? "active" : ""
                  }`}
              >
                <div className="top01">
                  <div className="icon01">
                    <AdminPanelSettingsIcon className="Home02" />
                  </div>
                  <div className="name01">
                    <h1 className="text01">Role Management</h1>
                  </div>
                </div>
              </Link>
            </div>
          )
        }
        {
          permissions.includes("view_resource") && (
            <div className="last">
              <Link
                to="/backoffice/adminmanagement"
                className={`CommonName ${location.pathname === "/backoffice/adminmanagement" ? "active" : ""
                  }`}
              >
                <div className="top01">
                  <div className="icon01">
                    {/* Icon for Admin: perhaps a user with a tie or a tool icon */}
                    <PermContactCalendarIcon className="Home02" />{" "}
                    {/* Or <FaUserTie /> for a more 'admin' look */}
                  </div>
                  <div className="name01">
                    <h1 className="text01">Resource Management</h1>
                  </div>
                </div>
              </Link>
            </div>
          )}
        {
          permissions.includes("view_category") && (
            <div className="last">
              <Link
                to="/backoffice/category"
                className={`CommonName ${location.pathname === "/backoffice/category" ? "active" : ""
                  }`}
              >
                <div className="top01">
                  <div className="icon01">
                    <CategoryIcon className="Home02" />
                  </div>
                  <div className="name01">
                    <h1 className="text01">Category Management</h1>
                  </div>
                </div>
              </Link>
            </div>
          )
        }

        {
          permissions.includes("view_product") && (
            <div className="last">
              <Link
                to="/backoffice/productmanagement"
                className={`CommonName ${location.pathname === "/backoffice/productmanagement" ? "active"
                  : location.pathname === '/createproduct' ? "active" : ""
                  }`}
              >
                <div className="top01">
                  <div className="icon01">
                    <FaBoxes className="Home02" />{" "}
                  </div>
                  <div className="name01">
                    <h1 className="text01">Product Management</h1>
                  </div>
                </div>
              </Link>
            </div>
          )

        }
        {
          permissions.includes("view_order") && (
            <div className="last">
              <Link
                to="/backoffice/order"
                className={`CommonName ${location.pathname === "/backoffice/order" ? "active" : ""
                  }`}
              >
                <div className="top01">
                  <div className="icon01">
                    <MdShoppingBag className="Home02" />{" "}
                  </div>
                  <div className="name01">
                    <h1 className="text01">Order Management</h1>
                  </div>
                </div>
              </Link>
            </div>
          )
        }
        {
          permissions.includes("view_blog") && (
            <div className="last">
              <Link
                to="/backoffice/blogmanagement"
                className={`CommonName
               ${location.pathname === "/backoffice/blogmanagement" ? "active"
                    : location.pathname === "/blogcreate" ? "active"
                      : location.pathname === `/backoffice/blogmanagementupdate/${id}` ? "active" : ""
                  }`}
              >
                <div className="top01">
                  <div className="icon01">
                    <FaNewspaper className="Home02" />{" "}
                  </div>
                  <div className="name01">
                    <h1 className="text01">Blog Management</h1>
                  </div>
                </div>
              </Link>
            </div>
          )
        }

        {
          permissions.includes("view_wishlist") && (
            <div className="last">
              <Link
                to="/backoffice/wishlist"
                className={`CommonName ${location.pathname === "/backoffice/wishlist" ? "active" : ""
                  }`}
              >
                <div className="top01">
                  <div className="icon01">
                    <FaHeart className="Home02" />{" "}
                  </div>
                  <div className="name01">
                    <h1 className="text01">Wishlist</h1>
                  </div>
                </div>
              </Link>
            </div>
          )}
        {
          permissions.includes("view_cart") && (
            <div className="last">
              <Link
                to="/backoffice/cart"
                className={`CommonName ${location.pathname === "/backoffice/cart" ? "active" : ""
                  }`}
              >
                <div className="top01">
                  <div className="icon01">
                    <FaShoppingCart className="Home02" />{" "}
                  </div>
                  <div className="name01">
                    <h1 className="text01">Cart</h1>
                  </div>
                </div>
              </Link>
            </div>
          )}

        {
          permissions.includes("view_revenue") && (
            <div className="last">
              <Link
                to="/backoffice/revenue"
                className={`CommonName ${location.pathname === "/backoffice/revenue" ? "active" : ""
                  }`}
              >
                <div className="top01">
                  <div className="icon01">
                    <FaChartLine className="Home02" />{" "}
                  </div>
                  <div className="name01">
                    <h1 className="text01">Revenue</h1>
                  </div>
                </div>
              </Link>
            </div>
          )}

        {
          permissions.includes("view_drone") && (
            <div className="last">
              <Link
                // to="/backoffice/dronemanagement"
                to="/backoffice/dronebooking"
                className={`CommonName ${location.pathname === "/backoffice/dronebooking" ? "active" : ""
                  }`}
              >
                <div className="top01">
                  <div className="icon01">
                    <FaPlane className="Home02" />

                  </div>
                  <div className="name01">
                    <h1 className="text01">Drone Bookings</h1>
                  </div>
                </div>
              </Link>
            </div>
          )}

          {
          permissions.includes("view_dronemanagement") && (
            <div className="last">
              <Link
                to="/backoffice/dronemanagement"
                className={`CommonName ${location.pathname === "/backoffice/dronemanagement" ? "active" : ""
                  }`}
              >
                <div className="top01">
                  <div className="icon01">
                    <FaShippingFast  className="Home02" />

                  </div>
                  <div className="name01">
                    <h1 className="text01">Drone Management</h1>
                  </div>
                </div>
              </Link>
            </div>
          )}


        {
          permissions.includes("view_soiltest") && (
            <div className="last">
              <Link
                to="/backoffice/soiltesting"
                className={`CommonName ${location.pathname === "/backoffice/soiltesting" ? "active" : ""
                  }`}
              >
                <div className="top01">
                  <div className="icon01">
                    {/* Icon for Soil Testing: a flask or a droplet for liquids/soil */}
                    <FaFlask className="Home02" />{" "}
                    {/* Or <FiDroplet className="Home02" /> */}
                  </div>
                  <div className="name01">
                    <h1 className="text01">Soil Testing</h1>
                  </div>
                </div>
              </Link>
            </div>
          )}

        {
          permissions.includes("view_farmdata") && (
            <div className="last">
              <Link
                to="/backoffice/farmprecision"
                className={`CommonName ${location.pathname === "/backoffice/farmprecision" ? "active" : ""
                  }`}
              >
                <div className="top01">
                  <div className="icon01">
                    {/* Icon for Farm Precision: a leaf (agriculture) or a target (precision) */}
                    <FaLeaf className="Home02" />{" "}
                    {/* Or <FiTarget className="Home02" /> or <FiTractor className="Home02" /> */}
                  </div>
                  <div className="name01">
                    <h1 className="text01">Farm Precision</h1>
                  </div>
                </div>
              </Link>
            </div>
          )}


        {
          permissions.includes("view_enquiries") && (
            <div className="last">
              <Link
                to="/backoffice/enquirymanagement"
                className={`CommonName ${location.pathname === "/backoffice/enquirymanagement" ? "active" : ""
                  }`}
              >
                <div className="top01">
                  <div className="icon01">
                    {/* Icon for Enquiry Management: a question mark or help circle */}
                    <FaQuestionCircle className="Home02" />{" "}
                    {/* Or <FiHelpCircle className="Home02" /> */}
                  </div>
                  <div className="name01">
                    <h1 className="text01">Enquiry Management</h1>
                  </div>
                </div>
              </Link>
            </div>
          )}

        {
          permissions.includes("view_newsletter") && (
            <div className="last">
              <Link
                to="/backoffice/newsletter"
                className={`CommonName ${location.pathname === "/backoffice/newsletter" ? "active" : ""
                  }`}
              >
                <div className="top01">
                  <div className="icon01">
                    {/* Icon for Newsletter Management: an open envelope or mail icon */}
                    <FaEnvelopeOpenText className="Home02" />{" "}
                    {/* Or <FiMail className="Home02" /> */}
                  </div>
                  <div className="name01">
                    <h1 className="text01">Newsletter Management</h1>
                  </div>
                </div>
              </Link>
            </div>
          )}


  {
          permissions.includes("view_subscription") && (
            <div className="last">
              <Link
                to="/backoffice/subscription"
                className={`CommonName ${location.pathname === "/backoffice/subscription" ? "active" : ""
                  }`}
              >
                <div className="top01">
                  <div className="icon01">
                    {/* Icon for Newsletter Management: an open envelope or mail icon */}
                    {/* <FaEnvelopeOpenText className="Home02" />{" "} */}
                              <FaReceipt className="Home02" /> {/* Changed icon to FaReceipt */}

                    {/* Or <FiMail className="Home02" /> */}
                  </div>
                  <div className="name01">
                    <h1 className="text01">Subscription Management</h1>
                  </div>
                </div>
              </Link>
            </div>
          )}

           <div className="last">
              <Link
                to="/backoffice/servicesenquiry"
                className={`CommonName ${location.pathname === "/backoffice/servicesenquiry" ? "active" : ""
                  }`}
              >
                <div className="top01">
                  <div className="icon01">
                    {/* Icon for Newsletter Management: an open envelope or mail icon */}
                    {/* <FaEnvelopeOpenText className="Home02" />{" "} */}
                              <FaReceipt className="Home02" /> {/* Changed icon to FaReceipt */}

                    {/* Or <FiMail className="Home02" /> */}
                  </div>
                  <div className="name01">
                    <h1 className="text01">Services Enquiry</h1>
                  </div>
                </div>
              </Link>
            </div>



        {/* <div className="last">
          <Link
            to="/backoffice/backoffice/admin/login"
            className={`CommonName ${
              location.pathname === "/login" ? "active" : ""
            }`}
          >
            <div className="top01">
              <div className="icon01">
                <FaCircleExclamation className="Home02" />
              </div>
              <div className="name01">
                <h1 className="text01">Logout</h1>
              </div>
            </div>
          </Link>
        </div> */}


        <div className="last" style={{ marginBottom: "60px" }}>
          <ToastContainer />
          <div
            className={`CommonName ${location.pathname === "/logout-confirm" ? "active" : ""
              }`}
            onClick={handleLogoutClick}
            style={{ cursor: 'pointer' }}
          >
            <div className="top01">
              <div className="icon01">
                <FaCircleExclamation className="Home02" />
              </div>
              <div className="name01">
                <h1 className="text01">Logout</h1>
              </div>
            </div>
          </div>
        </div>

      </nav>

      {/* --- LOGOUT CONFIRMATION MODAL --- */}
      <Modal show={showLogoutConfirm} onHide={handleCloseLogoutConfirm} centered>

        <Modal.Body className="text-center">
          <h4 className="fw-bold mb-3">Confirm Logout</h4> {/* Title from your image */}
          <p className="m-0">Are you sure you want to logout?</p> {/* Message from your image */}
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-center border-0 pt-0">
          <Button
            variant="danger" // Red background
            onClick={handleConfirmLogout}
            style={{
              borderRadius: '50px',
              padding: '10px 30px',
              fontWeight: 'bold',
              backgroundColor: '#dc3545', // Red
              borderColor: '#dc3545',
              color: 'white',
            }}
          >
            Yes
          </Button>
          <Button
            variant="success" // Green background
            onClick={handleCloseLogoutConfirm}
            style={{
              borderRadius: '50px',
              padding: '10px 30px',
              fontWeight: 'bold',
              backgroundColor: '#28a745', // Green
              borderColor: '#28a745',
              color: 'white'
            }}
          >
            No
          </Button>
        </Modal.Footer>
      </Modal>

    </div>
  );
}
